// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","multiplesRatios":"_1kFg4k-hoiw5TU6ccQq_Bm","fundamentals":"_3dnhEQ-6nVV5VCl0gKoM3r","marketCap":"_3dR127LvFAAJ8uvG3I1-iq"};